// extracted by mini-css-extract-plugin
export default {"inline":"EventTime_inline__zo5t-"};